export default "__VITE_ASSET__CyCX2VdD__"